var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardIcoZip16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V13L4 16V13H1V0H15ZM2 12H4V3L11.333 1H2V12Z",
    fill: "#FF8314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1438 6.82606C13.5309 6.71507 13.845 6.95179 13.845 7.35448V8.99999C13.8449 10.1045 12.9842 11.2468 11.9225 11.5513C10.8608 11.8557 10.0002 11.2069 10 10.1025V8.45703C10 8.05434 10.3141 7.63746 10.7012 7.52646L13.1438 6.82606ZM11.8822 9.06089C11.5505 9.15613 11.2814 9.51307 11.2814 9.85816C11.2816 10.203 11.5506 10.4058 11.8822 10.3109L11.9629 10.2877C12.2944 10.1925 12.5634 9.83537 12.5637 9.49046C12.5637 9.14542 12.2945 8.94285 11.9629 9.03774L11.8822 9.06089ZM13.2443 4.92226C13.5761 4.82712 13.845 5.02982 13.845 5.37499C13.845 5.72012 13.576 6.07713 13.2443 6.17226L10.6008 6.93027C10.269 7.02539 10.0001 6.82263 10 6.47754C10 6.13237 10.269 5.77541 10.6008 5.68027L13.2443 4.92226ZM13.2443 3.04726C13.5761 2.95212 13.845 3.15482 13.845 3.49999C13.845 3.84513 13.576 4.20213 13.2443 4.29726L10.6008 5.05527C10.269 5.1504 10 4.94766 10 4.60254C10 4.25737 10.269 3.90041 10.6008 3.80527L13.2443 3.04726ZM13.2443 1.17226C13.5761 1.07712 13.845 1.27982 13.845 1.62499C13.845 1.97015 13.576 2.32712 13.2443 2.42226L10.6008 3.18027C10.269 3.2754 10 3.07269 10 2.72754C10 2.38237 10.269 2.02541 10.6008 1.93027L13.2443 1.17226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIcoZip16);
export default __webpack_public_path__ + "static/media/Board_ico_zip_16.14c7d4ea62f95183aa32baded00ef02d.svg";
export { ForwardRef as ReactComponent };